import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrganisationRemoveStoreCreditPage } from 'src/app/modals/organisation-remove-store-credit/organisation-remove-store-credit.page';

const routes: Routes = [
  {
    path: '',
    component: OrganisationRemoveStoreCreditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrganisationRemoveStoreCreditPage]
})
export class OrganisationRemoveStoreCreditPageModule {}
